
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H1V.5a.5.5 0 00-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M17 21.5a7 7 0 10-7-7 7 7 0 007 7zm0-13a6 6 0 11-6 6 6 6 0 016-6z"}}),_c('path',{attrs:{"d":"M16.65 14.85L19 17.22a.5.5 0 10.7-.71l-2.21-2.22v-3.93a.5.5 0 00-1 0v4.14a.51.51 0 00.15.35zM3 15a.5.5 0 00.34-.14l6.14-5.74 1.12.28a.5.5 0 00.24-.97l-1.4-.34A.5.5 0 009 8.2l-6.33 5.92A.5.5 0 003 15zm16.21-8.27a.5.5 0 00.4-.2L22.4 2.8a.5.5 0 00-.8-.6l-2.79 3.73a.5.5 0 00.4.8z"}})])
          )
        }
      }
    